import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=4e7601c9&scoped=true&"
import script from "./CustomerSummary.vue?vue&type=script&lang=js&"
export * from "./CustomerSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7601c9",
  null
  
)

export default component.exports